import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

const FeedbackCard = ({
  customer_name,
  merchant,
  feedback,
  rating_driver,
  rating_mile1,
  order_id,
  driver,
  date,
}) => {
  return (
    <Fragment>
      <style type="text/css">
        {`
    .btn-flat {
      background-color: #B8D5B6;
      color: white;
      margin-bottom: 10px;
      width: 100%;
    }
    .bg-flat {
      background-color: #E6E7E8;
      color: #534741;
      border-radius: 15px;  
    }
    .card-deck .card  {
      margin-bottom: 10px;  
      font-size: 1.2rem;
      display: flex;
    }
    .btn-xxl {
      padding: 10px;
      font-size: 1.2rem;
    }
    `}
      </style>
      <Card
        bg="flat"
        border="dark"
        style={{ minWidth: "300px", maxWidth: "300px" }}
      >
        <Card.Header className="d-flex justify-content-between">
          {merchant} <span className="text-secondary">{date}</span>
        </Card.Header>
        <Card.Body>
          <Card.Title>
            <Link to={`/fulfillments/${order_id}`}>
              <span className="text-dark">{customer_name}</span>
            </Link>
          </Card.Title>
          <Card.Text>
            <Button variant="flat" size="xxl">
              <span className="text-dark">{driver}</span> -{" "}
              <span className="text-dark">{rating_driver}</span> <br></br>
              <span className="text-dark">Mile1</span> -{" "}
              <span className="text-dark">{rating_mile1}</span>
            </Button>
            <span>{feedback}</span>
          </Card.Text>
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default FeedbackCard;
